import { kstFull, kstShort } from "../../inquiry/view";
import { ResTag } from "./Tags";
import { PER, pageWindow, linkKind, langTxt, chTxt, storeName, nf } from "./logic";
import { clickable } from "../../v6common/a11y";

// 시안 renderChat 의 목록(표·모바일 카드·질문만)과 chPager
const EMPTY_TXT = "조건에 맞는 대화가 없습니다";

export function Pager({ page, total, onPage }) {
    const pages = Math.max(1, Math.ceil(total / PER));
    const range = total ? `${(page - 1) * PER + 1} - ${Math.min(page * PER, total)}` : "0";
    return (
        <div className="pager chpager"><span>{range} / 총 {nf(total)}건</span>
            <span className="pg">
                <button disabled={page <= 1} onClick={() => onPage(page - 1)}><i className="fa-solid fa-chevron-left"></i> 이전</button>
                {pageWindow(page, pages).map((i, k) => (i === "…"
                    ? <span key={`e${k}`} className="ell">…</span>
                    : <button key={i} className={i === page ? "on" : ""} onClick={() => onPage(i)}>{i}</button>))}
                <button disabled={page >= pages} onClick={() => onPage(page + 1)}>다음 <i className="fa-solid fa-chevron-right"></i></button>
            </span></div>
    );
}

function LinkCell({ s, go }) {
    const stop = (e) => e.stopPropagation();
    switch (linkKind(s)) {
        case "linked":
            return <a href={`#inquiry-${s.inquiry_id}`} style={{ color: "var(--pri)", fontWeight: 700 }}
                onClick={(e) => { e.preventDefault(); stop(e); go("inquiry", { openId: s.inquiry_id }); }}>No.{s.inquiry_id}</a>;
        case "missing": return <span style={{ color: "var(--red)", fontWeight: 700 }}>미등록</span>;
        default: return <span style={{ color: "var(--tx3)" }}>-</span>;
    }
}

const resp = (s) => (s.first_response_sec != null ? `${Math.round(s.first_response_sec * 10) / 10}초` : "-");
const catName = (s) => s.quick_category?.name || "-";

export function QuestionList({ items, onOpen }) {
    return (
        <div className="hqwrap">
            {items.length ? items.map((s) => (
                <div key={s.session_id} className="hq" onClick={() => onOpen(s.session_id)}><ResTag result={s.result} />
                    <span className="qt">{s.first_question || "(질문 없음)"}</span><span className="t">{storeName(s)} · {kstShort(s.started_at)}</span></div>
            )) : <div className="empty">{EMPTY_TXT}</div>}
        </div>
    );
}

export function SessionTable({ items, onOpen, go }) {
    return (<>
        <div className="tbl-wrap chat-tbl" style={{ maxHeight: "none", minHeight: 0 }}>
            <table className="tbl chtbl">
                <thead><tr><th>일시</th><th>매장</th><th>첫 질문</th><th>분류</th><th>언어 · 채널</th><th className="num">턴</th><th className="num">응답</th><th>결과</th><th>연결 문의</th></tr></thead>
                <tbody>
                    {items.length ? items.map((s) => (
                        <tr key={s.session_id} {...clickable(() => onOpen(s.session_id))}>
                            <td className="c-dt">{kstFull(s.started_at).slice(2)}</td>
                            <td><b>{storeName(s)}</b></td>
                            <td className="q">{s.first_question || ""}</td>
                            <td style={{ color: "var(--tx2)" }}>{catName(s)}</td>
                            <td style={{ color: "var(--tx2)" }}>{`${langTxt(s.lang)} · ${chTxt(s.channel)}`}</td>
                            <td className="num">{s.turns}</td>
                            <td className="num">{resp(s)}</td>
                            <td><ResTag result={s.result} /></td>
                            <td><LinkCell s={s} go={go} /></td>
                        </tr>
                    )) : <tr><td colSpan="9"><div className="empty">{EMPTY_TXT}</div></td></tr>}
                </tbody>
            </table>
        </div>
        <div className="mcards">
            {items.length ? items.map((s) => {
                const k = linkKind(s);
                return (
                    <div key={s.session_id} className="mc" {...clickable(() => onOpen(s.session_id))}>
                        <div className="mc-top"><ResTag result={s.result} /><span className="t">{kstShort(s.started_at)}</span></div>
                        <b>{storeName(s)}</b><p>{s.first_question || ""}</p>
                        <div className="mc-foot"><span>{`${catName(s)} · ${langTxt(s.lang)} · ${chTxt(s.channel)}`}</span>
                            {k === "linked" ? <span style={{ color: "var(--pri)", fontWeight: 700 }}>No.{s.inquiry_id}</span> : k === "missing" ? <span className="none">미등록</span> : null}</div>
                    </div>
                );
            }) : <div className="empty">{EMPTY_TXT}</div>}
        </div>
    </>);
}
